import type React from 'react';

export const NotFound: React.FC = () => {
	return <div>404 page not found</div>;
};
